import { gql } from '../../../../../hooks'

export const GET_RESULTS_BY_SAMPLE_GRAPH = gql`
  query GetResultsBySampleGraph($id: ID!) {
    t4ResultsBySampleGraph(id: $id) {
    }
  }
`
